import { useEffect,useState } from 'react'
import Spreed from 'react-spreadsheet'
import { WhiteboxLoader } from '../../components/Loader/Loader'
import { useNotification } from '../../services/usenotification'
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import Grid from '@mui/material/Grid'
import GreenButton from '../../components/buttons/green-button'
import { Download } from '@mui/icons-material'
import { useTranslation } from 'react-multi-lang'
import { useLocation, useParams  } from 'react-router-dom';

import { convertDate } from '../../services/convertDate';
import NoData from '../../assets/images/bg/no_data.png'
import './spreedsheet.scss'

import { useAPI } from '../../services/hoc/useAPI';
import { expenses_response, iExpensesFetchData, img_url, sells_report_response } from '../../services/api/api';
import { AxiosError } from 'axios';
import { ImageLinkCell } from './img_column';

export const SpreedSheet=()=>{
const [dataControl,setDataControl]=useState<{fetching:boolean
    ,data:{value:any}[][],data_raw:any[]}>({fetching:true,data:[],data_raw:[]})
const {path,date_to,date_from,id}=useParams()

const location=useLocation()
const t=useTranslation()
const api = useAPI()
const {alert,alertError500}=useNotification()

const downlaod =()=>{
    const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";


    const ws = XLSX.utils.json_to_sheet(dataControl.data_raw);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, 'fileName' + fileExtension);
}

const getclientReport=(date_from:string,date_to:string,client_id:number)=>{
   
    api.reportControl()
    .clietntReport({date_from:convertDate(date_from)
        ,date_to:convertDate(date_to),client_id})
        .then((res:any)=>{
            if (res.data && res.data.length>0){handleData(res.data)}
            else {
        alert({en:'It appears there is no data , try change the parameters'
        ,ar:'لا يوجد معلومات لاظهارها , حاول التغيير في بارامترات الادخال'},'info'
        )
        setDataControl(pre=>({...pre ,fetching:false,data:[]}))
        }
        })
        .catch(err=>{
            alertError500(err)
        })
}

const getDebtReport=(date_from:string,date_to:string)=>{
    api.reportControl()
    .debtReoport({date_from:convertDate(date_from)
        ,date_to:convertDate(date_to)})
        .then((res:any)=>{
            if (res.data && res.data.length>0){handleData(res.data)}
            else {
        alert({en:'It appears there is no data , try change the parameters'
        ,ar:'لا يوجد معلومات لاظهارها , حاول التغيير في بارامترات الادخال'},'info'
        )
        setDataControl(pre=>({...pre ,fetching:false,data:[]}))
        }
        })
        .catch(err=>{
            alertError500(err)
        })
}


const getOwerReport=(date_from:string,date_to:string)=>{
    api.reportControl()
    .owerReport({date_from:convertDate(date_from)
        ,date_to:convertDate(date_to)})
        .then((res:any)=>{
            if (res.data && res.data.length>0){handleData(res.data)}
            else {
        alert({en:'It appears there is no data , try change the parameters'
        ,ar:'لا يوجد معلومات لاظهارها , حاول التغيير في بارامترات الادخال'},'info'
        )
        setDataControl(pre=>({...pre ,fetching:false,data:[]}))
        }
        })
        .catch(err=>{
            alertError500(err)
        })
}


const getPayVoucherReport=(date_from:string,date_to:string)=>{
    api.reportControl()
    .payVoucherReport({date_from:convertDate(date_from)
        ,date_to:convertDate(date_to)})
        .then((res:any)=>{
            if (res.data && res.data.length>0){handleData(res.data)}
            else {
        alert({en:'It appears there is no data , try change the parameters'
        ,ar:'لا يوجد معلومات لاظهارها , حاول التغيير في بارامترات الادخال'},'info'
        )
        setDataControl(pre=>({...pre ,fetching:false,data:[]}))
        }
        })
        .catch(err=>{
            alertError500(err)
        })
}


const getPurchaseReport=(date_from:string,date_to:string)=>{
    api.reportControl()
    .purcahseReport({date_from:convertDate(date_from)
        ,date_to:convertDate(date_to)})
        .then((res:any)=>{
            if (res.data && res.data.length>0){handleData(res.data)}
            else {
        alert({en:'It appears there is no data , try change the parameters'
        ,ar:'لا يوجد معلومات لاظهارها , حاول التغيير في بارامترات الادخال'},'info'
        )
        setDataControl(pre=>({...pre ,fetching:false,data:[]}))
        }
        })
        .catch(err=>{
            alertError500(err)
        })
}


const getRecieptVoucherReport=(date_from:string,date_to:string)=>{
    api.reportControl()
    .recieptVoucherReport({date_from:convertDate(date_from)
        ,date_to:convertDate(date_to)})
        .then((res:any)=>{
            if (res.data && res.data.length>0){handleData(res.data)}
            else {
        alert({en:'It appears there is no data , try change the parameters'
        ,ar:'لا يوجد معلومات لاظهارها , حاول التغيير في بارامترات الادخال'},'info'
        )
        setDataControl(pre=>({...pre ,fetching:false,data:[]}))
        }
        })
        .catch(err=>{
            alertError500(err)
        })
}


const getSupplierReport=(date_from:string,date_to:string,supplier_id:number)=>{
    api.reportControl()
    .supplierReport({date_from:convertDate(date_from)
        ,date_to:convertDate(date_to),supplier_id})
        .then((res:any)=>{
            if (res.data && res.data.length>0){handleData(res.data)}
            else {
        alert({en:'It appears there is no data , try change the parameters'
        ,ar:'لا يوجد معلومات لاظهارها , حاول التغيير في بارامترات الادخال'},'info'
        )
        setDataControl(pre=>({...pre ,fetching:false,data:[]}))
        }
        })
        .catch(err=>{
            alertError500(err)
        })
}


const getProductionReport=(date_from:string,date_to:string)=> {
    api.reportControl()
    .productionReport({date_from:convertDate(date_from)
        ,date_to:convertDate(date_to)})
    .then((res:any)=>{
   
        if (res.data && res.data.length>0){handleData(res.data)}
        else {
    alert({en:'It appears there is no data , try change the parameters'
    ,ar:'لا يوجد معلومات لاظهارها , حاول التغيير في بارامترات الادخال'},'info'
    )
    setDataControl(pre=>({...pre ,fetching:false,data:[]}))
    }
    })
    .catch(err=>{
        alertError500(err)
    })
}


const getInventoryReport=(date_from:string,date_to:string)=> {
    api.reportControl()
    .inventoryReport({date_from:convertDate(date_from)
        ,date_to:convertDate(date_to)})
    .then((res:any)=>{
  
        if (res.data && res.data.length>0){handleData(res.data)}
        else {
    alert({en:'It appears there is no data , try change the parameters'
    ,ar:'لا يوجد معلومات لاظهارها , حاول التغيير في بارامترات الادخال'},'info'
    )
    setDataControl(pre=>({...pre ,fetching:false,data:[]}))
    }
    })
    .catch(err=>{
        alertError500(err)
    })
}

const getSalesReport=(date_from:string,date_to:string)=> {
    api.reportControl()
    .salesReport({date_from:convertDate(date_from)
        ,date_to:convertDate(date_to)})
    .then((res)=>{

        if (res.data && res.data.length>0){
            let formated_data:sells_report_response[] = res.data.map(ele=>({
                ...ele,
                net_after_tax:Math.floor(ele.net_after_tax),
                paid:Math.floor(ele.paid),
                remains:Math.floor(ele.remains),
                description:ele.description?ele.description.split('/')[1]:''
                 
            }))
            handleData(formated_data)
        }
        else {
    alert({en:'It appears there is no data , try change the parameters'
    ,ar:'لا يوجد معلومات لاظهارها , حاول التغيير في بارامترات الادخال'},'info'
    )
    setDataControl(pre=>({...pre ,fetching:false,data:[]}))
    }
    })
    .catch(err=>{
        alertError500(err)
    })
}

const getExpenses = (
    fetch_props: iExpensesFetchData
  ) => {
   

    let { page, page_size = 1000, keyword, sort_direction, sort_field, date_from, date_to } = fetch_props
    
    api.expenses().index({
      page
      , page_size
      , keyword,
      sort_direction
      , sort_field
      , date_from
      , date_to

    })
      .then((response) => {
     
        
      
        // if (response.data.data.last_page)setPagesInfo(pre=>({...pre,lastPage:response.data.data.last_page}))
        let paymentVouchers: expenses_response[] = response.data.data.vouchers.map((p): expenses_response => 
            ({
                expense_date:p.expense_date,
                expense_type_name:p.expense_type_name,
                expense_type_code:p.expense_type_code,
                expense_value:p.expense_value,
                vat:p.vat,
                tax_num:p.tax_num,
                expense_mode:p.expense_mode,
                invoice_num:p.invoice_num,
                invoice_date:p.invoice_date,
                notes:p.notes,
                invoice_copy: img_url+ p.invoice_copy
            }))
        handleData(paymentVouchers)
      })
      .catch((err: AxiosError) => {
        alertError500(err)
       
      })
  }


const handleData=(data:any[])=>{
    let headers:string[]=[]
   Object.keys(data[0]).map(ele=> {
        if(!headers.includes(ele)){
            headers.push(ele)
        }
    })
    let new_data=[headers.map(ele=>({value:t(ele)}))]
 data.map(ele=> {
    let arr:any[]=[]
       headers.map(key=> arr.push({value:ele[key]}))
       new_data.push(arr)

    })
    setDataControl({fetching:false,data:new_data,
        data_raw:data.map(ele=>{
        let new_obj:any={}
         Object.keys(ele).map(elem=>{
            new_obj[t(elem)]=ele[elem]
        })
        return new_obj
    })})
}
    useEffect(()=>{
        if (date_from && date_to) {
            switch(path) {
                case 'getSupplierReport':
                    getSupplierReport(date_from,date_to,id?parseInt(id):0)
                    break;
                case  'getRecieptVoucherReport'  :
                    getRecieptVoucherReport(date_from,date_to)
                    break;
                case  'getPurchaseReport':
                    getPurchaseReport(date_from,date_to)
                    break;
                case  'getPayVoucherReport':
                    getPayVoucherReport(date_from,date_to)
                    break;
                case   'getOwerReport':
                    getOwerReport(date_from,date_to)
                    break;
                case    'getDebtReport':
                    getDebtReport(date_from,date_to)
                    break;
                case     'getclientReport':
                    getclientReport(date_from,date_to,id?parseInt(id):0)
                    break;
                case     'getProductionReport':
                    getProductionReport(date_from,date_to)
                    break;
                case 'getInventoryReport':
                    getInventoryReport(date_from,date_to)
                    break;
                case 'getSalesReport':
                    getSalesReport(date_from,date_to)
                    break;
                case 'getExpenses': 
                     getExpenses({page:1,date_from,date_to,keyword:id})    


            }
        }
     
    },[location])
//console.log('data',dataControl)
if (dataControl.fetching) {
    return <WhiteboxLoader />
}

else {
    if (dataControl.data && dataControl.data.length>0)
        
    {return (
        <Grid container rowGap={4} justifyContent={'center'} >
        
            <Grid  container size={12}
            className='custom_spreedsheet'
           sx={{'direction':'ltr'}}
            >

                <Spreed
                        
                        data={dataControl.data.map((row, row_index) => {
                            // keep header row unchanged
                            if (path!=='getExpenses') return row
                            if (row_index === 0) return row;

                            // IMPORTANT: return the mapped row
                            return row.map((cell, cell_index) => {
                            if (cell_index === 10) {
                                return {
                                value: cell.value,
                                DataViewer: ImageLinkCell
                                };
                            }

                            return cell;
                            });
                        })}
                        />

            </Grid>
            <Grid  container size={12} justifyContent={'center'}>
                <Grid  container size={4}>
                    <GreenButton 
                    label={t("download")}
                    fun={()=>downlaod()}
                    >
                        <Download sx={{color:'white'}} />
                    </GreenButton>
                </Grid>
            
            </Grid>
        </Grid>
    )}
    else {
        return (
            <Grid container
            justifyContent={'center'} alignItems={'center'} 
            flexDirection={'column'}
            rowGap={4}>
                <Grid  size ={6} sx={{margin:{xs:'4rem 0'}}}>
                    <img src={NoData}/>
                </Grid>
                <Grid size={5}>
                <GreenButton
                    label={t('close_page')}
                    fun={() => window.close()}
                    fullWidth={true}
                    disabled={false}
                    />

                </Grid>
            </Grid>
        )
    }
}
}